import { Swup, SwupScriptsPlugin } from '@hh/global.js'

class HHMainContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const headScripts = document.querySelectorAll('head script')
    headScripts.forEach(script => {
      if (script.textContent.includes('Globo') || script.src.includes('globo.formbuilder.index.js')) {
        script.setAttribute('data-swup-reload-script', '')
      }
    })

    const swup = new Swup({
      containers: ['.js-swup-update-main-content', '.js-swup-update-seo'],
      linkSelector: '.js-swup-link',
      timeout: 5000,
      plugins: [new SwupScriptsPlugin({
        optin: true,
      })]
    })

    swup.hooks.on('visit:start', (visit) => {
      visit.scroll.reset = false;
    })
  }
}

customElements.define('hh-main-content', HHMainContent);